import { Box, Typography, Button, Avatar } from "@mui/material";
import React, { useState } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { GolfCourse } from "@mui/icons-material";

interface CardItemProps {
  title: string;
  category: string[];
  summary: string;
  author: string;
  createdAt: { seconds: number; nanoseconds: number } | string;
  sourceOfKnowledge: string;
  type: string;
  price: string;
  coverPhotoUrl: string;
  profilePicture: string;
  onClick: () => void;
  goToProfile?: () => void;
}

const CommonCardData: React.FC<CardItemProps> = ({
  title,
  category,
  summary,
  author,
  createdAt,
  sourceOfKnowledge,
  type,
  price,
  coverPhotoUrl,
  profilePicture,
  onClick,
  goToProfile,
}) => {
  const [showFullSummary, setShowFullSummary] = useState(false);
  const [showFullTitle, setShowFullTitle] = useState(false);

  const toggleSummary = () => {
    setShowFullSummary((prev) => !prev);
  };

  const truncatedSummary =
    summary?.length > 200 ? `${summary.slice(0, 200)}...` : summary;

  const truncatedTitle =
    title?.length > 50 ? `${title.slice(0, 50)}...` : title;

  return (
    <Box
      sx={{
        ...styleSheet.container,
        width: { xs: "100%", lg: "100%", md: "100%", xl: "290px" },
        height: { xs: "100%", lg: "100%", md: "100%", xl: "600px" },
        backgroundColor: { xs: "white", md: "white" },
      }}
    >
      <Box
        component="img"
        src={coverPhotoUrl}
        alt={title}
        sx={styleSheet.containerImg}
      />
      <Box p={2}>
        <Typography
          fontWeight={700}
          fontSize={{ xs: 14, md: 18 }}
          color={"#233F91"}
          gutterBottom
        >
          {showFullTitle ? title : truncatedTitle}
          {/* {title} */}
        </Typography>
        {/* 
        
       */}
        <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
          {(Array.isArray(category) ? category.slice(0, 2) : []).map((tag, index) => (
            <Button key={index} variant="contained" sx={styleSheet.tagContainer}>
              {tag}
            </Button>
          ))}

        </Box>
        <Typography
          variant="body2"
          fontSize={{ xs: 13, md: 15 }}
          fontWeight={400}
          color="#6C6C6C"
          mb={2}
        >
          {/* {summary} */}
          {showFullSummary ? summary : truncatedSummary}
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={1}
          mb={2}
        >
          <Box
            display={"flex"}
            gap={1}
            alignItems={"center"}
            sx={{ cursor: "pointer" }}
            onClick={goToProfile}
          >
            <Avatar
              alt={author}
              src={profilePicture}
              sx={{ width: { xs: 25, md: 27 }, height: { xs: 25, md: 27 } }}
            />
            <Typography
              fontSize={{ xs: 13, md: 17 }}
              fontWeight={400}
              color="#575757"
            >
              {author}
            </Typography>
          </Box>
          <Box
            component="span"
            sx={{
              display: { xs: "flex", md: "block" },
              justifyContent: "flex-end",
              color: "#5EA472",
              fontWeight: "700",
              fontSize: { xs: "16px", md: "18px" },
            }}
          >
            ${price}
          </Box>
        </Box>
        <Typography
          fontWeight={400}
          fontSize={{ xs: 13, md: 15 }}
          color="textSecondary"
        >
          <Box component="span" sx={{ color: "#545454" }}>
            <FiberManualRecordIcon
              sx={{
                color: "#00A79D",
                mr: "1px",
                width: { xs: 5, md: 7 },
                height: { xs: 5, md: 7 },
              }}
            />


            {Array.isArray(sourceOfKnowledge)
              ? sourceOfKnowledge.join(", ")
              : sourceOfKnowledge.replace(/\//g, " / ")}
          </Box>
          <Box display="flex" justifyContent="space-between" mt={"10px"}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography
                fontWeight={400}
                fontSize={{ xs: 13, md: 15 }}
                color="textSecondary"
              >
                {typeof createdAt === "object" && "seconds" in createdAt
                  ? new Date(createdAt.seconds * 1000).toLocaleDateString()
                  : createdAt}
              </Typography>
              <Box>
                <Box component="span" sx={{ color: "#545454" }}>
                  <FiberManualRecordIcon
                    sx={{
                      color: "#00A79D",
                      mr: "1px",
                      width: { xs: 5, md: 7 },
                      height: { xs: 5, md: 7 },
                    }}
                  />

                  {type}
                </Box>
              </Box>
            </Box>
            <Box
              onClick={onClick}
              sx={{ cursor: "pointer" }}
              display={"flex"}
              gap={"3px"}
              alignItems={"center"}
            >
              <RemoveRedEyeIcon
                sx={{
                  width: "17.12px",
                  height: "17.12px",
                  color: "#797979",
                }}
              />
              <Typography
                fontSize={"12.33px"}
                fontWeight={700}
                color={"#797979"}
              >
                Preview
              </Typography>
            </Box>
          </Box>

          {/* <Box
            component="span"
            sx={{
              display: { xs: "block", md: "none" },
              color: "#93989A",
              fontWeight: "700",
              fontSize: { xs: "16px", md: "18px" },
              ml: 2,
            }}
          >
            {price}
          </Box> */}
        </Typography>
      </Box>
    </Box>
  );
};

export default CommonCardData;

const styleSheet = {
  container: {
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "hidden",
    // height: "593px",
  },
  containerImg: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    borderRadius: "5px 5px 5px 5px",
  },
  tagContainer: {
    bgcolor: "#233F91",
    color: "#fff",
    padding: "10px",
    borderRadius: "15px",
    fontSize: { xs: "13px", md: "14px" },
    fontWeight: 700,
    // width: "100.81px",
    // Padding: "8.96px, 10.4px, 8.96px, 10.4px",
    height: "31px",
  },
};
